import { useEffect, useState } from 'react';
/**
 * useViewport — hook responsive breakpoints (Wave M5-webapp).
 *
 * Aligné sur Tailwind defaults : md=768px, lg=1024px, xl=1280px.
 *
 *   - mobile   : < 768px       (smartphones)
 *   - tablet   : 768-1023px    (iPad portrait, foldables)
 *   - desktop  : >= 1024px     (iPad landscape, laptops, desktops)
 *
 * SSR-safe : retourne mobile par défaut côté serveur (mobile-first cyanotype).
 *
 * Usage :
 *   const { isMobile, isTablet, isDesktop, width } = useViewport();
 */
export const VIEWPORT_BREAKPOINTS = {
    tablet: 768,
    desktop: 1024,
    wide: 1280,
};
export function getViewportFromWidth(width) {
    return {
        width,
        isMobile: width < VIEWPORT_BREAKPOINTS.tablet,
        isTablet: width >= VIEWPORT_BREAKPOINTS.tablet && width < VIEWPORT_BREAKPOINTS.desktop,
        isDesktop: width >= VIEWPORT_BREAKPOINTS.desktop,
        isWide: width >= VIEWPORT_BREAKPOINTS.wide,
    };
}
function readViewport() {
    if (typeof window === 'undefined') {
        return getViewportFromWidth(375);
    }
    return getViewportFromWidth(window.innerWidth);
}
export function useViewport() {
    const [state, setState] = useState(() => readViewport());
    useEffect(() => {
        if (typeof window === 'undefined')
            return;
        const onResize = () => setState(readViewport());
        window.addEventListener('resize', onResize);
        onResize();
        return () => window.removeEventListener('resize', onResize);
    }, []);
    return state;
}
//# sourceMappingURL=useViewport.js.map